export class PromiseResult {
    success: boolean = null;
    error: ErrorModel = null;
    data: any = null;
}

export class ErrorModel {
    code: string = null;
    message: string = null;
}

export class ServerError {
    statusCode: number = null;
    message: string | string[] = null;
    error: string = null;
}

export class ApiCallsData {
    isOnce: boolean = false;
    isVisted: boolean = false;
}

export class ApiResult {
    PromiseResult: PromiseResult = new PromiseResult();
    ServerError: ServerError = new ServerError();
    ErrorModel: ErrorModel = new ErrorModel();
    Posting: boolean = true;
    Calls: ApiCallsData = new ApiCallsData();
    constructor(posting?: boolean) {
        this.Posting = posting;
    }
}
